module.exports = __webpack_public_path__ + "media/images/new-ui-images/task-gray-fd44bdca5d160190224630e03bd94d30.svg";